export default __webpack_public_path__ + "static/media/sc1.c969d29b.png";